/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleBookingDisplaysRequest
 */
export interface VehicleBookingDisplaysRequest {
    /**
     * VehicleBooking ids to fetch display details for.
     * @type {Array<number>}
     * @memberof VehicleBookingDisplaysRequest
     */
    bookingIds: Array<number>;
}

/**
 * Check if a given object implements the VehicleBookingDisplaysRequest interface.
 */
export function instanceOfVehicleBookingDisplaysRequest(value: object): value is VehicleBookingDisplaysRequest {
    if (!('bookingIds' in value) || value['bookingIds'] === undefined) return false;
    return true;
}

export function VehicleBookingDisplaysRequestFromJSON(json: any): VehicleBookingDisplaysRequest {
    return VehicleBookingDisplaysRequestFromJSONTyped(json, false);
}

export function VehicleBookingDisplaysRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingDisplaysRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingIds': json['booking_ids'],
    };
}

export function VehicleBookingDisplaysRequestToJSON(json: any): VehicleBookingDisplaysRequest {
    return VehicleBookingDisplaysRequestToJSONTyped(json, false);
}

export function VehicleBookingDisplaysRequestToJSONTyped(value?: VehicleBookingDisplaysRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_ids': value['bookingIds'],
    };
}

